import React from 'react';
export default function siteHeader(props) {
    return (React.createElement("div", { className: 'row font-white siteheader-container' },
        React.createElement("div", { className: 'small-9 medium-7 large-7 large-offset-1 columns siteheader siteheader-logo' },
            React.createElement("a", { href: 'http://www.uni-muenchen.de' },
                React.createElement("img", { src: 'https://cms-static.uni-muenchen.de/default/foundation-zuv/img/header-smartphone.png', className: 'helper-no-resize hide-for-medium-up logo-small' }))),
        React.createElement("div", { className: 'small-3 medium-5 large-3 end columns siteheader' },
            React.createElement("span", { className: 'button tiny right' },
                React.createElement("span", { style: { fontSize: 12 }, className: 'fi-torso' }),
                React.createElement("span", { className: 'siteheader-name' }, "\u00A0\u00A0")))));
}
